import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./Pages/Home";
import Insurance from "./Pages/Insurance";
import Companies from "./Pages/Companies/index.js";
import CompaniesManage from "./Pages/CompaniesManage";
import CompaniesAdd from "./Pages/CompaniesAdd";
import CompaniesEdit from "./Pages/CompaniesEdit";
import Users from "./Pages/Users";
import Providers from "./Pages/Providers";
import Strategies from "./Pages/Strategies";
import SubmittedBusiness from "./Pages/SubmittedBusiness";
import StatementsIn from "./Pages/StatementsIn";
import StatementsInSummary from "./Pages/StatementsInSummary";
import Login from "./Pages/Login";
import Compliance from "./Pages/Compliance";
import Matching from "./Pages/Matching";
import Helpers from "./Pages/Helpers";
import MainProviders from "./Pages/MainProviders";
import Matched from "./Pages/Matched";
import AdvisorStatementsList from "./Pages/AdvisorStatementsList";
import AdvisorStatements from "./Pages/AdvisorStatements";
import Consolidator from "./Pages/Consolidator";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/new-record",
    element: <Home />,
  },
  {
    path: "/insurance",
    element: <Insurance />,
  },
  {
    path: "/submitted",
    element: <SubmittedBusiness />,
  },
  {
    path: "/statements-in/:summaryID",
    element: <StatementsIn />,
  },
  {
    path: "/statements-in/summary",
    element: <StatementsInSummary />,
  },
  {
    path: "/companies",
    element: <Companies />,
  },
  {
    path: "/companies/add",
    element: <CompaniesAdd />,
  },
  {
    path: "/companies/edit/:companyID",
    element: <CompaniesEdit />,
  },
  {
    path: "/users",
    element: <Users />,
  },
  {
    path: "/providers",
    element: <Providers />,
  },
  {
    path: "/strategies",
    element: <Strategies />,
  },
  {
    path: "/compliance",
    element: <Compliance />,
  },
  {
    path: "/matching",
    element: <Matching />,
  },
  {
    path: "/matched/:summaryID/:statementID",
    element: <Matched />,
  },
  {
    path: "/consolidator",
    element: <Consolidator />,
  },
  {
    path: "/advisor-statement",
    element: <AdvisorStatements />,
  },
  {
    path: "/advisor-statements",
    element: <AdvisorStatementsList />,
  },
  {
    path: "/helpers",
    element: <Helpers />,
  },
    {
    path: "/main-providers",
    element: <MainProviders />,
  },
]);

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <RouterProvider router={router} />
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
